import { loadable } from '@Components/Utilities/SandhillsLoadable';

const TextSignUpModal = loadable(() => import('@Components/Shared/Modals/TextSignUpModal'), true);

const LazyTextSignUpModal = (props) => {

    return (
        <TextSignUpModal {...props}/> 
    );
};

export default LazyTextSignUpModal;
global.LazyTextSignUpModal = LazyTextSignUpModal;